import { Grid, Typography } from '@mui/material';
import styles from '../Information.module.scss';

const YouthandEducation = () => {
  const programs = [
    {
      id: 1,
      programName: "Bala Jyothi classes",
      image: "/images/templeimagenew.svg"
    },
    {
      id: 2,
      programName: "Graduation Saraswati puja",
      image: "/images/shivatemple.svg"
    },
    {
      id: 3,
      programName: "Navarathri Golu Musical program",
      image: "/images/shivatemple.svg"
    },
    {
      id: 4,
      programName: "Bhakti Jyothi classes",
      image: "/images/templeimagenew.svg"
    },
    {
      id: 5,
      programName: "Bhagavad gita discussions",
      image: "/images/templeimagenew.svg"
    },
    {
      id: 6,
      programName: "Ganesha Chathurthi Children's program",
      image: "/images/shivatemple.svg"
    },
    {
      id: 7,
      programName: "Bhagavad Gita and Vishnushasranamam classes",
      image: "/images/templeimagenew.svg"
    },
    {
      id: 8,
      programName: "Youth forum",
      image: "/images/shivatemple.svg"
    },
    {
      id: 9,
      programName: "Art and Craft exhibitions",
      image: "/images/shivatemple.svg"
    },
    {
      id: 10,
      programName: "Sanskrit classes",
      image: "/images/shivatemple.svg"
    },
    {
      id: 11,
      programName: "Summer Reading Program",
      image: "/images/shivatemple.svg"
    },
    {
      id: 12,
      programName: "Sanskrit Camps",
      image: "/images/templeimagenew.svg"
    },
    {
      id: 13,
      programName: "Youth volunteer credit programs",
      image: "/images/templeimagenew.svg"
    },
    {
      id: 14,
      programName: "Spelling and Math bee",
      image: "/images/templeimagenew.svg"
    },
    {
      id: 15,
      programName: "Sanskrit as a Foreign Language program",
      image: "/images/shivatemple.svg"
    }
  ]
  const hinduismItems = [
    'Religious Texts such as Ramayana, Mahabharata, Bhagawad Gita, Bhagavatam, Upanishads etc.',
    'Indian Culture',
    'Indian History',
    'Indian/Hindu Philosophy and Spiritualism',
    'Books for Children like Amar Chitra Katha, Panchatantra etc.'
  ];
  programs.sort((a, b) => a.programName.localeCompare(b.programName));
  return (
    <>
    <div className={styles.Youthandeducation}>
      <div className={styles.cardContainer}>
        <Grid sx={{ padding: "24px" }}>
          <Typography className={styles.content}>
            1.To establish a full-fledged Learning Center which includes a library and conducting regular classes for enabling religious, cultural and spiritual learning for Asian-Indian children, youth and adults in the Northern California Community. The key elements of the center will include:
              <Typography>
                <ul>
               <li>An extensive state-of-the-art library housing authoritative books and audio-visual media on Vedic literature, religion and Indian history and culture in English and several Indian languages.</li> 
                <li>Discourses and classes for youth and adults</li>
                </ul>
                2.To establish systems and conduct regular youth workshops that inspire the youth by increasing their awareness of the spiritual and cultural richness of our heritage.<br />
                3. To continuously advance the Learning Center though networking with other religious, cultural and spiritual learning centers around the world.
              </Typography>
          </Typography>
          <Grid sx={{ marginTop: "54px" }}>
            <Typography className={styles.headercontent}>Key Events Celebrated at the Temple</Typography>
            <Grid sx={{marginTop:"20px", marginLeft: "-10px"}}>
              <div style={{ width: "100%" }}>
                {programs.map((offered, id) => (
                  <div key={offered.id} style={{ display: "inline-block" }}>
                    <div className={styles.container}>
                      <Grid container alignItems="center" className={styles.grid}>
                        <div style={{ display: "inline-flex", alignItems: "center" }}>
                          <img src={offered.image} className={styles.images}/>
                          <div className={styles.offeredNameDiv}>
                            <Typography className={styles.offeredName} title={offered.programName}>{offered.programName}</Typography>
                          </div>
                        </div>
                      </Grid>
                    </div>
                  </div>
                ))}

              </div>
            </Grid>
          </Grid>
          <Grid>
            <Typography className={styles.headercontent}>Library</Typography>
          </Grid>
          <Grid>
            <Typography>
              1.The HCCC library is housed in administrative building and open on Saturdays and Sundays from 10:30AM to 3:30PM.<br />
              2.HCCC would be grateful to devotees for making generous donations of books, Audio-Visual material and/or monetary help for the development of the HCCC Learning Center. Books are media should ideally be one of the following subjects:<br />
              <div className="hinduism-list">
                <ul>
                  {hinduismItems.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </Typography>
          </Grid>
        </Grid>
      </div>
      </div>
    </>
  )
}
export default YouthandEducation;